
interface CompanyType {
    link: string;
    image: string;
    name: string;
}

const STATIC_COMPANY_DATA: CompanyType = {
    link: 'https://www.ametras.com',
    image: 'https://www.nagel-gruppe.de/assets/images/logo-nagel.png',
    name: 'AMETRAS Informatik AG'
};

export {STATIC_COMPANY_DATA};
